<template>
  <el-table-column :label="label" :prop="prop" class-name="registration-symbol" :sortable="sortable" />
</template>

<script>
export default {
  components: {
  },
  props: {
    label: {
      type: String,
      default: '登録記号'
    },
    prop: {
      type: String,
      default: 'registration_symbol'
    },
    sortable: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.el-table {
  th,
  td {
    &.registration-symbol {
      width: 8em;
    }
  }
}
</style>
